import React, { useContext, useState, useEffect } from 'react'
import {
  Container,
  Grid,
  Typography,
  createMuiTheme,
  InputAdornment,
  ThemeProvider
} from '@material-ui/core'
import MaterialTextField from '@material-ui/core/TextField'
import { containerStyle } from '../styles/styles'

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { AMNTextField, AMNTextArea, AMNRadioButtonsGroup } from '@amn/shared'

import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import { textFieldTheme, radioButtonTheme, textAreaTheme } from '../App'

const UnitContainer = (props) => {
  const classes = containerStyle()
  const [result, setResult] = useState(props.value ? props.value.length : 0)
  const [error, setError] = useState(false)

  const chargeExperienceData = [
    {
      id: '1',
      value: 'Yes'
    },
    {
      id: '2',
      value: 'No'
    },
    {
      id: '3',
      value: 'N/A'
    }
  ]

  //   const telemetryData = [
  //     {
  //       id: "1",
  //       value: "Yes",
  //     },
  //     {
  //       id: "2",
  //       value: "No",
  //     },
  //   ];

  const handleChange = (event) => {
    props.updateReference(props.index, {
      [event.target.id]: event.target.value
    })

    if (event.target.required) setError(!event.target.value)
  }

  const radioButtonChanged = (event, key) => {
    let bool
    if (event.target.value === 'Yes') bool = true
    else if (event.target.value === 'No') bool = false
    else if (event.target.value === 'N/A') bool = null
    props.updateReference(props.index, {
      [key]: bool
    })
  }

  //   const handleRadioInputTelemetry = () => {
  //     if (props.isEvaluator) {
  //       if (props.reference.telemetryMonitoring === true) return "Yes";
  //       else if (props.reference.telemetryMonitoring === false) return "No";
  //     }
  //   };

  const handleRadioInput = () => {
    if (props.reference.chargeExperience === true) return 'Yes'
    else if (props.reference.chargeExperience === false) return 'No'
    else if (props.reference.chargeExperience === null) return 'N/A'
  }

  function HandleCharacter (event) {
    const letterCount = event.target.value.length || 0
    setResult(letterCount)
    props.updateReference(props.index, {
      [event.target.id]: event.target.value
    })
    if (event.target.required) setError(!event.target.value)
  }

  return (
    <div className={classes.separationDottedBorder}>
      <form className={classes.root} noValidate autoComplete='off'>
        <Typography variant='h5'>Unit</Typography>
        <div className={classes.inputField}>
          <AMNTextField
            id='unitName'
            label='Unit/Floor/Dept'
            variant='filled'
            errorText='Required'
            required
            error={(props.error || error) && !props.reference.unitName}
            className={classes.unitDescription}
            value={props.reference.unitName}
            onChange={(e) => handleChange(e)}
            theme={textFieldTheme}
          />
        </div>

        {/* to be added when discipline specific questions are available */}
        {/* {props.isEvaluator ? (
          <div className={classes.inputField}>
            <FormControl component='fieldset'>
              <FormLabel
                component='legend'
                className={classes.chargeExperienceLabel}
                error={
                  (error || props.error) &&
                  props.reference.telemetryMonitoring === undefined
                }
              >
                Does this unit have Telemetry monitoring?
              </FormLabel>
              <AMNRadioButtonsGroup
                dir
                data={telemetryData}
                type
                value={handleRadioInputTelemetry}
                len={2}
                onChange={(e) => radioButtonChanged(e, 'telemetryMonitoring')}
              />
            </FormControl>
            <Grid>
              <Typography variant='caption' style={{ color: '#ff0000' }}>
                {(error || props.error) &&
                props.reference.telemetryMonitoring === undefined
                  ? 'Required'
                  : null}
              </Typography>
            </Grid>
          </div>
        ) : null} */}
        <div className={classes.inputField}>
          <ThemeProvider theme={textAreaTheme}>
            <AMNTextArea
              id='unitDescription'
              className={classes.unitDescription}
              multiline
              required
              error={(props.error || error) && !props.reference.unitDescription}
              maxCharacter='500'
              label='Unit Description'
              value={props.reference.unitDescription}
              variant='filled'
              onChange={(e) => HandleCharacter(e)}
              helperText='May include common patient diagnoses, patient acuity, software, special equipment used, special skills/competencies, etc.'
              errorText='May include common patient diagnoses, patient acuity, software, special equipment used, special skills/competencies, etc.'
              theme={textAreaTheme}
            />
          </ThemeProvider>
        </div>
        <div className={classes.inputField}>
          <AMNTextField
            id='positionHeld'
            errorText='Required'
            label='Your Position Held'
            error={(props.error || error) && !props.reference.positionHeld}
            variant='filled'
            className={classes.unitDescription}
            value={props.reference.positionHeld}
            onChange={(e) => handleChange(e)}
            required
            theme={textFieldTheme}
          />
        </div>
        <div className={classes.inputField}>
          <FormControl component='fieldset'>
            <FormLabel
              component='legend'
              className={classes.chargeExperienceLabel}
              error={
                (error || props.error) &&
                props.reference.chargeExperience === undefined
              }
            >
              <Typography variant='body2'>
                Supervisor Experience?
              </Typography>
            </FormLabel>
            <ThemeProvider theme={radioButtonTheme}>
              <AMNRadioButtonsGroup
                dir
                data={chargeExperienceData}
                type
                value={handleRadioInput}
                len={3}
                onChange={(e) => radioButtonChanged(e, 'chargeExperience')}
              />
            </ThemeProvider>
          </FormControl>
          <Grid>
            <Typography variant='caption' style={{ color: '#D9553D' }}>
              {(error || props.error) &&
              props.reference.chargeExperience === undefined
                ? 'Required'
                : null}
            </Typography>
          </Grid>
        </div>
      </form>
    </div>
  )
}

export default UnitContainer
